module.exports = __webpack_public_path__ + "img/turkiye-is-bankasi-tilt-machine-03.a40e8e97.jpg";